import { Component, OnInit, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-isomasters-slider',
  templateUrl: './isomasters-slider.component.html',
  styleUrls: ['./isomasters-slider.component.scss'],
})
export class IsomastersSliderComponent implements OnInit {
  @Input() max: number;
  @Input() min: number;
  @Input() set value(value: number) {
    this._val = value;
  }
  get value() {
    return this._val;
  }
  @Output() valueChange = new EventEmitter<number>();
  @Input() step: number;

  private _val: number;
  constructor(
    private domSanatizer: DomSanitizer,
    private changeDetector: ChangeDetectorRef
  ) {}

  get style(): SafeStyle {
    const styleString = `--min: ${this.min};
                         --max: ${this.max};
                         --val: ${this._val || 50}`;
    return this.domSanatizer.bypassSecurityTrustStyle(styleString);
  }
  ngOnInit() {
    this._val = this.value;
    this.changeDetector.detectChanges();
  }

  setProgress(target: HTMLInputElement) {
    if (!target.validity.valid || !target.value) {
      return;
    }
    this._val = +target.value;
    this.valueChange.emit(this._val);
  }
}
